// Footer component
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
	footer: {
		width: '100%',
		bottom: 0,
		height: '50px',
		background: 'black',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '20px',
		alignItems: 'center',
		borderRadius: '5px 5px 0 0',
		position: 'absolute'
	},
	text: {
		color: 'rgb(106, 130, 255)'
	}
}));

const Footer = () => {
	const classes = useStyles();

	return (
		<>
			<div className={classes.footer}>
				<Button
					href="https://www.ascslab.org"
					color="primary"
					className={classes.text}
				>
					STAM Center
				</Button>
				<span className={classes.text}>gauge@asu.edu</span>
			</div>
		</>
	);
};

export default Footer;
